import axios from 'axios';

export const SITE_URL = 'https://newbrain.com.ua';

const siteApi = axios.create({
  baseURL: `${SITE_URL}/api`,
  headers: { Accept: 'application/json' },
});

export function getTrialAvailability() {
  return siteApi.get('/trial-signup/availability');
}

export function createTrialDraft(data) {
  return siteApi.post('/trial-signup/draft', data);
}

export const siteAsset = (path) => {
  if (!path) return '';
  return /^https?:\/\//.test(path) ? path : `${SITE_URL}${path.startsWith('/') ? '' : '/'}${path}`;
};
